<script lang="ts">
    import { writable } from "svelte/store";
    import { makeTimeString } from "../Services/Helpers";
    import VolumeCtrl from "./VolumeCtrl.svelte";

    export let src: string;

    const percent = writable<number>(0);

    let audioElement: HTMLAudioElement;
    let isPlaying: boolean = false;
    let duration: string = '';
    let time: string = '00:00';
    let volumeIndex: number = 1;
    let showVolumeDropdown = false;

    function onToggleClick(): void {
        if (!audioElement) {
            return;
        }
        isPlaying = !isPlaying;
        if (isPlaying) {
            audioElement.play();
        } else {
            audioElement.pause();
        }
    }

    function onTimeupdate() {
        percent.set(audioElement.currentTime / audioElement.duration);
        time = makeTimeString(audioElement.currentTime);
    }

    function onLoadedmetadata() {
        duration = makeTimeString(audioElement.duration);
    }

    function onVolumeControlChange(event: CustomEvent<number>) {
        if (!audioElement) {
            return;
        }
        audioElement.volume = event.detail;
        volumeIndex = Math.min(3, Math.floor(event.detail / 0.25));
    }

    function onVolueClick(event: MouseEvent) {
        event.stopPropagation();
        const target = event.target as HTMLElement;
        if (target.closest('.volume-dropdown')) {
            return;
        }
        toggleVolumeControl();
    }

    function toggleVolumeControl() {
        showVolumeDropdown = !showVolumeDropdown;
    }

    function hideVolumeControl() {
        showVolumeDropdown = false;
    }

</script>
<style lang="scss">

    .audio-player {
        display: flex;
        align-items: center;
        gap: 1rem;
        padding: 1rem;
        background-color: var(--color-secondary);
    }

    .toggle-btn {
        width: 3rem;
        height: 3rem;
        border: none;
        border-radius: 50%;
        background-color: rgba(var(--color-aux-rgb), 0.23);
        background-repeat: no-repeat;
        background-position: center;
        background-size: 1rem 1rem;

        &.is-playing {
            background-image: url('/images/icon-pause.svg');
        }

        &.is-paused {
            background-image: url('/images/icon-play.svg');
        }
    }

    .progress {
        flex: 1 1 0;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .meta {
            display: flex;
            justify-content: space-between;
            color: #fff;
            font-size: 0.7em;
        }
    }

    .progress-bar {
        height: 10px;
        background-color: #fff;
        border-radius: 500px;
        overflow: hidden;

        .bar {
            width: 0%;
            height: 100%;
            background-color: var(--color-aux);
        }
    }

    .volume {
        position: relative;
        width: 3rem;
        height: 3rem;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 2rem;
    }

    .volume-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 10rem;
        background-color: red;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        display: none;

        &.show {
            display: flex;
        }
    }

</style>

<svelte:head>
    <link rel="preload" href="/images/icon-volume-0.svg" as="image">
    <link rel="preload" href="/images/icon-volume-1.svg" as="image">
    <link rel="preload" href="/images/icon-volume-2.svg" as="image">
    <link rel="preload" href="/images/icon-volume-3.svg" as="image">
</svelte:head>

<svelte:window on:click={hideVolumeControl} />

<!-- svelte-ignore a11y-media-has-caption -->
<audio src={src} bind:this={audioElement} on:timeupdate={onTimeupdate} on:loadedmetadata={onLoadedmetadata}></audio>

<div class="audio-player">
    
    <button
        type="button"
        class="toggle-btn {isPlaying ? 'is-playing' : 'is-paused'}"
        on:click={onToggleClick}></button>

    <div class="progress">

        <div class="meta">
            <div>{time}</div>
            <div>{duration}</div>
        </div>

        <div class="progress-bar">
            <div class="bar" style="width: {$percent * 100}%"></div>
        </div>

    </div>

    <div class="volume" style="background-image: url('/images/icon-volume-{volumeIndex}.svg');" on:click={onVolueClick}>
        <div class="volume-dropdown" class:show={showVolumeDropdown}>
            <!-- <input type="range" min="0" max="1" step="0.05" on:input={onVolumeControlChange}> -->
            <VolumeCtrl on:change={onVolumeControlChange} />
        </div>
    </div>

</div>
